import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import {
  BannerInternas,
  Conteudo,
  Secao,
  SecaoBotaoVoltar,
  SecaoCabecalho,
  SecaoTitulo,
  Tradutor,
  // BotaoLinkExterno,
  // TextoBotao,
} from './styles';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

const SecaoGramado = ({ idPage, api, ...props }) => {
  const { t } = useTranslation();
  const { lang } = useParams();
  const secaoId = t('slugs.gramado');
  const [gramado, setGramado] = useState();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    _handleGetGramdo();
    return function cleanup() {};
  }, []);

  const _handleGetGramdo = async () => {
    await api.get(`/blnews/${idPage}`).then((response) => {
      const dados = response.data[0];
      const dado = {
        title: '',
        content: '',
        image: dados.image,
        image_description: dados.image_description,
      };

      if (lang !== 'pt') {
        dado.title = dados['title_' + lang];
        dado.content = dados['content_' + lang];
        dado.description = dados['description_' + lang];
      } else {
        dado.title = dados.title;
        dado.content = dados.content;
        dado.description = dados.description;
      }

      setGramado(dado);
      setIsLoading(true);
    });
  };

  return (
    <Secao id={secaoId} className="mb-4">
      <SecaoCabecalho className="mb-4">
        <SecaoTitulo>
          <Tradutor path={isLoading ? gramado.title : ''} />
        </SecaoTitulo>
        <SecaoBotaoVoltar />
      </SecaoCabecalho>
      <BannerInternas
        src={isLoading ? gramado.image : ''}
        alt={isLoading ? gramado.image_description : ''}
        className="mb-4 mt-70"
      />
      <Conteudo
        dangerouslySetInnerHTML={{
          __html: isLoading ? gramado.content : '',
        }}
      />
      {/* <BotaoLinkExterno
        href="https://www.sicc.com.br/cupom-de-descontos-31-edicao-SICC.pdf"
        title="Baixe o programa de benefícios do CVB"
        target="_blank"
      >
        <TextoBotao>
          <Tradutor path="paginas.inicial.secaoGramado.cupomDesconto" />
        </TextoBotao>
      </BotaoLinkExterno> */}
    </Secao>
  );
};

SecaoGramado.propTypes = {
  idPage: PropTypes.any,
  api: PropTypes.any,
};

export default SecaoGramado;
